import { API, Navbar, NoTengo, Help, Sidebar, authenticationService, useGet } from '@enkla-gui'
import React, { useEffect, useState } from 'react'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import Modal from 'react-modal'
import OnboardingInProgress from './components/help/OnboardingInProgress'
import Announcements from '@components/system/Announcements'
import Pipey from '@components/help/Pipey'
import { PipeyProvider } from './providers/PipeyProvider';
import { ToastContainer } from 'react-toastify'
import User from '@components/layout/Navbar/User'
//eslint-disable-next-line
import { menu, routes, icons } from '@/_config'
import { registerLocale } from 'react-datepicker'
import { date, notify } from '@/_helpers'
import sv from 'date-fns/locale/sv'

// import the context provider
registerLocale('sv', sv)
require('moment/locale/sv')

const UserContext = React.createContext({})

function App() {
  const location = useLocation()
  const [currentToken, setCurrentToken] = useState(null)
  const [user, setUser] = useState({})
  const [task, setTask] = useState(false)
  const { data: tasks, fetch: refetchtasks } = useGet({ endpoint: 'api/task/onboarding', enabled: !!currentToken })
  const [billable, setBillable] = useState({})

  useEffect(() => {
    authenticationService.currentToken.subscribe(x => setCurrentToken(x))
    if (authenticationService.currentTokenValue) {
      API.get('api/auth/me').then(user => {
        setUser(user)
        // Set user context in Sentry
        Sentry.setUser({
          id: user.id?.toString()
        })
      })
      API.get(`api/auth/billable`).then(billable => setBillable(billable))
      authenticationService.refresh()
      //Refresh user access_token every 30 minutes
      setTimeout(() => {
        authenticationService.refresh()
      }, 1000 * 60 * 30)
    }
  }, [])

  useEffect(() => {
    if (!currentToken) return
    API.get('api/auth/me').then(user => {
      setUser(user)
      // Set user context in Sentry
      Sentry.setUser({
        id: user.id?.toString()
      })
    })
    API.get(`api/auth/billable`).then(billable => setBillable(billable))
    refetchtasks()
  }, [currentToken])
  const regret_delete = () => {
    API.post('api/billable/regret')
      .then(res => {
        notify.toast('Begäran om att radera kontot har tagits bort')
        setBillable({ ...billable, account_removal: null })
      })
      .catch(([err, res]) => {
        notify.toast(res.message, 'error')
      })
  }

  Modal.setAppElement('#root')

  return (
    <PipeyProvider>
      <UserContext.Provider value={{ task, user, billable, setTask, setBillable, setUser, tasks, refetchtasks }}>
        {currentToken && <Pipey />}
        <main class={currentToken ? 'content' : 'content login-content-wrapper'}>
          {currentToken && (
            <Sidebar getBadges={async () => await API.get('api/stats/badges')} logo='images/enkla-fastigheter.png' showOnboarding={user?.show_onboarding_in_sidebar} menu={menu} />
          )}
          <article class='d-flex flex-column flex-md-nowrap flex-grow-1 content-article' style={{ overflowY: currentToken ? 'auto' : 'none' }}>
            {currentToken && (
              <Navbar search={async query => await API.get('api/search', [['query', query]])}>
                <User />
              </Navbar>
            )}
            <div class={currentToken ? 'container' : ''}>
              <Announcements />
              <OnboardingInProgress />
              <ToastContainer />
              {currentToken && billable?.account_removal &&
                <Help type='danger' title="Du har begärt att ditt konto ska raderas" icon={icons.warning}>
                  <div >
                    Kontot kommer att tas bort permanent om <b>{date.until(billable.account_removal.created_at + (30 * 24 * 60 * 60))} dagar.</b>
                    <a class="btn btn-danger btn-sm pull-right" onClick={_ => regret_delete()}>Klick här för att ångra</a>
                  </div>
                </Help>
              }
              <Switch>
                <Route
                  exact
                  path='/'
                  render={() => {
                    return <Redirect to='/dashboard' />
                  }}
                />
                {routes.map(route => (
                  <Route
                    key={`route_${route.path}`}
                    path={route.path}
                    exact={route.exact || false}
                    render={props => {
                      if (!route.public && !authenticationService.currentTokenValue) return <Redirect to={{ pathname: '/login', state: { from: location } }} />
                      return <route.component.default {...props} />
                    }}
                  />
                ))}
                <Route path='*'>
                  <NoTengo />
                </Route>
              </Switch>
            </div>
          </article>
        </main>
      </UserContext.Provider>
    </PipeyProvider>
  )
}
export { UserContext }
export default App
